import React from "react";

const Rational = () => {
  return (
    <section className="py-4">
      <div className="container">
        <div className="position-relative overflow-hidden">
          <div className="py-3 z-index-2 position-relative">
            <div className="row">
              <div className="mx-auto text-left">
                <h3 className="mb-2">Rationale</h3>
                <p className="mb-3">
                  This non-degree course provides training in the tools and techniques used by healthcare professionals to monitor and evaluate
                  malaria programs in Africa. The program aims to fulfill a need for better SM&E support to generate high-quality data and to
                  analyze and use data to better inform program planning at the country level. 
                  <br />
                  <br />
                  The content will also include an introduction to
                  geographic information systems (GIS). GIS provides the ability to capture and analyze spatial and geographic data to create
                  interactive queries (user-created searches), store and edit spatial and non-spatial data, analyze spatial information output,
                  and visually share the results of these operations by presenting them as maps.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Rational;
